
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { marked } from 'marked';

import PanelTitle from './PanelTitle';

import Log from '../log';
const log = Log.getLogger('MultiSceneForApp.core.HomePanel');

const MarkdownViewer = ({ content, onLinkClick }) => {
    const classNames = mergeStyleSets({
        MarkdownViewer: {
            selectors: {
                '& h3': {
                    color: '#666666'
                }
            }
        },
    });

    const containerRef = React.useRef(null);

    React.useEffect(() => {
        const handleLinkClick = (e) => {
            const target = e.target;
            if (target.tagName === 'A') {
                e.preventDefault();
                const href = target.getAttribute('href');
                if (onLinkClick) {
                    onLinkClick(href);
                }

            }
        };

        const container = containerRef.current;
        container?.addEventListener('click', handleLinkClick);

        return () => {
            container?.removeEventListener('click', handleLinkClick);
        };
    }, [onLinkClick]);

    return (
        <div
            className={classNames.MarkdownViewer}
            ref={containerRef}
            dangerouslySetInnerHTML={{ __html: marked.parse(content) }}
        />
    );
}

const HomePanel = (props) => {

    const classNames = mergeStyleSets({
        HomePanel: {
            padding: 4
        },
        title: {
            fontSize: 14,
            fontWeight: 'bold',
            padding: '5px 0 5px 0'
        }
    });

    const linkClick = (href) => {
        if (href.startsWith('msfaCmd://')) {
            const cmdStr = decodeURI(href.substring(10));

            const match = cmdStr.match(/^(.+?)\((\{.*\})\)$/);
            if (!match) return null;

            const command = match[1];
            const paramString = match[2];

            try {
                const params = JSON.parse(paramString);
                MultiSceneForApp.executeCommand({
                    command,
                    ...params
                });
            } catch (e) {
                log.debug(`Error in parsing command: ${cmdStr}`);
            }
        } else {
            window.open(href, '_blank', 'noopener,noreferrer');
        }
    }

    return (
        <Stack verticalFill className={classNames.HomePanel} tokens={{childrenGap: 4}}>
            <Stack.Item align="stretch">
                <PanelTitle title="ÚVOD" />
            </Stack.Item>
            <Stack.Item>
                <MarkdownViewer
                    content={props.content}
                    onLinkClick={linkClick}
                />
            </Stack.Item>
        </Stack>
    );
}

export default HomePanel;
